import type { ConditionalWhenClause, LayoutNode } from './types';

function conditionalClauseRefQids(when: ConditionalWhenClause): string[] {
  if ('kind' in when && when.kind === 'repeatItemEq') return [];
  if ('derived' in when) return [];
  if ('includes' in when) return [when.qid];
  if ('eq' in when && 'qid' in when) return [when.qid];
  return [];
}

/** QIDs referenced by layout DSL (controls + predicates + weighted `sum` terms). */
export function collectLayoutReferencedQids(nodes: LayoutNode[]): Set<string> {
  const ids = new Set<string>();
  const walk = (arr: LayoutNode[]) => {
    for (const node of arr) {
      switch (node.type) {
        case 'card':
        case 'stack':
        case 'grid':
        case 'indent':
          walk(node.children);
          break;
        case 'divider':
        case 'static':
        case 'display':
        case 'section-label':
          break;
        case 'sum':
          for (const t of node.terms) ids.add(t.qid);
          break;
        case 'table':
          for (const row of node.rows) {
            for (const cell of row.cells) walk([cell]);
          }
          break;
        case 'conditional':
          conditionalClauseRefQids(node.when).forEach(q => ids.add(q));
          walk(node.children);
          if (node.elseChildren) walk(node.elseChildren);
          break;
        case 'disabled-when':
          for (const w of node.whenAll) {
            conditionalClauseRefQids(w).forEach(q => ids.add(q));
          }
          walk(node.children);
          break;
        case 'repeat':
          if (node.over.kind === 'multiselectOptionsOf') {
            ids.add(node.over.qid);
          }
          walk(node.children);
          break;
        case 'OASISRadio':
        case 'OASISText':
        case 'OASISDate':
        case 'OASISNumber':
          ids.add(node.qid);
          break;
        case 'OASISMultiselect':
          ids.add(node.qid);
          if (node.children) walk(node.children);
          break;
        case 'OASISMultiselectOption':
          break;
        case 'radio-option':
          ids.add(node.qid);
          break;
      }
    }
  };
  walk(nodes);
  return ids;
}
